import script from "D:\\experiments\\van3\\App.vue?type=script"
export * from "D:\\experiments\\van3\\App.vue?type=script"
export default script